import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderNewFlowUSIntakePreviewTemplate } from "themes/application/facility-order-new-flow-us-intake/pages";
import { FacilityOrderNewFlowUSIntakePreviewViewStore } from "application/facility-order-new-flow-us-intake/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderNewFlowUSIntakePreviewViewStore(rootStore), "facilityOrderNewFlowUSIntakePreviewViewStore")
@observer
class FacilityOrderNewFlowUSIntakePreview extends React.Component {
	render() {
		return <FacilityOrderNewFlowUSIntakePreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderNewFlowUSIntakePreview;